"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderInfoView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const svg_1 = require("@obvio/svg");
const ui_1 = require("@obvio/ui");
const react_1 = require("react");
const CheckoutHelp_1 = require("../../views/CheckoutView/CheckoutHelp");
const Divider = app_1.styled.div `
  height: 1px;
  width: 100%;
  background: ${(theme) => theme.stroke};
`;
const ElementWrap = app_1.styled.div ``;
const Title = (0, app_1.styled)(app_1.Text) `
  color: black !important;
  font-size: 1.25rem !important;
`;
const AuthInfo = (0, app_1.styled)(app_1.Text) `
  max-width: 26rem;
  color: ${(theme) => theme.colors.gray.semidark};
  padding-bottom: ${(theme) => theme.spacing.small};
`;
const FormWrap = (0, app_1.styled)(ui_1.Form) `
  display: grid;
  grid-template-columns: minmax(0, 4fr) minmax(0, 3fr) minmax(0, 2fr);
  grid-gap: ${(theme) => theme.spacing.extraSmall};
  @media only screen and (max-width: 1200px) {
    grid-template-columns: minmax(0, 4fr) minmax(0, 3fr);
    > button {
      grid-column: 2 span;
    }
  }
  @media only screen and (max-width: 460px) {
    grid-template-columns: minmax(0, 1fr);
    > button {
      grid-column: unset;
    }
  }
`;
const ContactBox = (0, app_1.styled)(ui_1.Grid) `
  background-color: #fbfbfb;
  padding: ${(theme) => theme.spacing.medium};
  align-items: start;
  grid-gap: ${(theme) => theme.spacing.small};
  @media only screen and (max-width: 460px) {
    grid-template-columns: minmax(0, 1fr);
    padding: ${(theme) => theme.spacing.medium} 0;
    background: unset;
    > div {
      justify-content: flex-start;
    }
  }
`;
const ContactLabel = (0, app_1.styled)(app_1.Text) `
  font-weight: 700;
  line-height: 150% !important;
  letter-spacing: 0.1px;
  font-size: 0.9375rem !important;
  padding-bottom: ${(theme) => theme.spacing.extraSmall};
  white-space: nowrap;
  color: black !important;
`;
const ContactInfo = (0, app_1.styled)(app_1.Text) `
  width: 100%;
  letter-spacing: 0.25px;
  font-size: 0.9375rem;
  line-height: 150%;
  color: black;
  @media ${app_1.mobile} {
    width: 100%;
    letter-spacing: 0.25px;
    font-size: 0.9375rem;
    line-height: 150%;
  }
`;
const OrderStatusInfo = app_1.styled.div `
  display: flex;
  font-size: 0.9375rem;
  > span {
    width: 100%;
  }
`;
const StyledCheck = (0, app_1.styled)(svg_1.SvgCheckCircle) `
  color: ${(theme) => theme.colors.success};
  margin-right: ${(theme) => theme.spacing.small};
`;
function AuthForm({ id }) {
    const { t } = (0, app_1.useTranslation)();
    const [authorize] = (0, app_1.useMutation)('authorizeOrderView', {
        refetchQueries: ['getOrderDetails'],
    });
    const handleSubmit = (data) => {
        void authorize({ number: data.number, email: data.email, id });
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(Title, Object.assign({ tag: "h2" }, { children: t('store.orderInfoTitle') })), (0, jsx_runtime_1.jsx)(AuthInfo, { children: t('store.orderInfoHelpText') }), (0, jsx_runtime_1.jsxs)(FormWrap, Object.assign({ onSubmit: handleSubmit }, { children: [(0, jsx_runtime_1.jsx)(ui_1.TextInput, { name: "email", label: t('label.email') }), (0, jsx_runtime_1.jsx)(ui_1.TextInput, { name: "number", label: t('label.orderNumber'), prefix: "#" }), (0, jsx_runtime_1.jsx)(ui_1.Submit, { children: t('label.logIn') })] }))] }));
}
const FlexWrap = app_1.styled.div `
  display: flex;
  flex-direction: column;
`;
function AdditionalShippingInfo({ title, value, authenticated, }) {
    const displayValue = value && authenticated;
    return ((0, jsx_runtime_1.jsxs)(FlexWrap, { children: [(0, jsx_runtime_1.jsx)(ContactLabel, Object.assign({ tag: "h3" }, { children: title })), (0, jsx_runtime_1.jsx)(ContactInfo, { children: displayValue ? value : (0, jsx_runtime_1.jsx)(ui_1.Skeleton, { rows: 1 }) })] }));
}
const ShippingWrap = app_1.styled.div `
  width: 100%;
`;
function ShippingInfo({ authenticated, email, phone, shippingInfo, }) {
    var _a;
    const displayValue = shippingInfo && authenticated;
    return ((0, jsx_runtime_1.jsxs)(ShippingWrap, { children: [displayValue ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ContactInfo, { children: `${shippingInfo.firstName} ${shippingInfo.lastName}` }), (0, jsx_runtime_1.jsx)(ContactInfo, { children: `${shippingInfo.address} ${(_a = shippingInfo.address2) !== null && _a !== void 0 ? _a : ''}` }), (0, jsx_runtime_1.jsx)(ContactInfo, { children: `${shippingInfo.postalCode} ${shippingInfo.city}` })] })) : ((0, jsx_runtime_1.jsx)(ui_1.Skeleton, { rows: 3 })), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {}), authenticated ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [phone && (0, jsx_runtime_1.jsx)(ContactInfo, { children: phone }), email && (0, jsx_runtime_1.jsx)(ContactInfo, { children: email })] })) : ((0, jsx_runtime_1.jsx)(ui_1.Skeleton, { rows: 2 }))] }));
}
const paymentMethods = {
    PRZELEWY24: { title: 'paymentMethod.przelewy24' },
    ON_DELIVERY: { title: 'paymentMethod.onDelivery' },
    CASH: { title: 'paymentMethod.cash' },
    CARD: { title: 'paymentMethod.card' },
    BANK_TRANSFER: { title: 'paymentMethod.bankTransfer' },
};
function RetryPaymentButton({ secret, }) {
    const { t } = (0, app_1.useTranslation)();
    const [checkStatus, { loading, data: status }] = (0, app_1.useCallbackQuery)('checkPaymentStatus');
    const [retryPayment] = (0, app_1.useMutation)('retryPayment', {
        onSuccess: (path) => {
            window.location.replace(path);
        },
    });
    (0, react_1.useEffect)(() => {
        void checkStatus({ secret });
    }, [checkStatus, secret]);
    (0, react_1.useEffect)(() => {
        if (status !== 'OK') {
            const interval = setInterval(() => {
                void checkStatus({ secret });
            }, 10000);
            return () => clearInterval(interval);
        }
    }, [checkStatus, secret, status]);
    if (status === 'OK') {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(ui_1.Button, Object.assign({ onClick: () => retryPayment({ secret }), loading: (loading && !status) || status === 'PROCESSING' }, { children: t('store.goToPaymentButton') })));
}
function OrderInfoView({ data, authenticated, loading, id, mail, }) {
    var _a, _b, _c;
    const searchPath = (0, app_1.useContextPath)('ecommerce.search');
    const { t } = (0, app_1.useTranslation)();
    const paymentMethodIntlId = (data === null || data === void 0 ? void 0 : data.paymentMethod) && ((_a = paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods[data.paymentMethod]) === null || _a === void 0 ? void 0 : _a.title);
    const displayRetryPayment = (data === null || data === void 0 ? void 0 : data.status) === 'ORDERED' && (data === null || data === void 0 ? void 0 : data.paymentMethod) === 'PRZELEWY24';
    return ((0, jsx_runtime_1.jsxs)(ui_1.Stack, Object.assign({ kind: "vertical", divider: Divider }, { children: [!authenticated && !loading ? (0, jsx_runtime_1.jsx)(AuthForm, { id: id }) : null, (0, jsx_runtime_1.jsxs)(ui_1.Stack, Object.assign({ kind: "vertical" }, { children: [(0, jsx_runtime_1.jsx)(Title, Object.assign({ tag: "h2" }, { children: authenticated && (data === null || data === void 0 ? void 0 : data.shippingAddress)
                            ? t('text.thankYouWithName', {
                                name: data.shippingAddress.firstName,
                            })
                            : t('text.thankYou') })), (0, jsx_runtime_1.jsxs)(OrderStatusInfo, { children: [(0, jsx_runtime_1.jsx)(StyledCheck, { height: "24px", width: "24px" }), (0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "span" }, { children: authenticated && !loading && (data === null || data === void 0 ? void 0 : data.number) ? (t('store.orderConfirmedInfo', {
                                    orderNumber: data.number,
                                })) : ((0, jsx_runtime_1.jsx)(ui_1.Skeleton, { rows: 2 })) }))] })] })), (0, jsx_runtime_1.jsxs)(ElementWrap, { children: [(0, jsx_runtime_1.jsx)(Title, Object.assign({ tag: "h2" }, { children: t.colon('label.contactInfo') })), (0, jsx_runtime_1.jsxs)(ContactBox, Object.assign({ templateColumns: "repeat(2, minmax(0,1fr))", templateRows: "repeat(2, minmax(0,1fr))" }, { children: [(0, jsx_runtime_1.jsx)(ui_1.GridItem, Object.assign({ rowSpan: "2", noCenter: true }, { children: (0, jsx_runtime_1.jsxs)(FlexWrap, { children: [(0, jsx_runtime_1.jsx)(ContactLabel, { children: t.colon('store.label.deliveryAddress') }), (0, jsx_runtime_1.jsx)(ShippingInfo, { authenticated: authenticated, email: data === null || data === void 0 ? void 0 : data.email, phone: data === null || data === void 0 ? void 0 : data.phone, shippingInfo: data === null || data === void 0 ? void 0 : data.shippingAddress })] }) })), (0, jsx_runtime_1.jsx)(ui_1.GridItem, { children: (0, jsx_runtime_1.jsx)(AdditionalShippingInfo, { title: t.colon('store.label.deliveryMethod'), value: loading ? undefined : (_c = (_b = data === null || data === void 0 ? void 0 : data.shipping) === null || _b === void 0 ? void 0 : _b.title) !== null && _c !== void 0 ? _c : '---', authenticated: authenticated }) }), (0, jsx_runtime_1.jsx)(ui_1.GridItem, { children: (0, jsx_runtime_1.jsx)(AdditionalShippingInfo, { title: t.colon('store.label.paymentMethod'), value: paymentMethodIntlId ? t(paymentMethodIntlId) : '', authenticated: authenticated }) })] }))] }), displayRetryPayment ? (0, jsx_runtime_1.jsx)(RetryPaymentButton, { secret: id }) : null, (0, jsx_runtime_1.jsx)(ui_1.Button, Object.assign({ href: searchPath }, { children: t('store.continueShoppingButton') })), (0, jsx_runtime_1.jsx)(CheckoutHelp_1.CheckoutHelp, { mail: mail })] })));
}
exports.OrderInfoView = OrderInfoView;
